import * as React from "react";
import { Navigate, Outlet } from "react-router-dom";

import { LoadingSkeleton } from "@/components/common/LoadingSkeleton";
import { useMultitenant } from "@/lib/modules";

/**
 * Routes that exist only on a multitenant deployment — the tenant registry.
 *
 * With the multitenant module off the deployment serves one tenant, there is
 * nothing to manage, and the API refuses the registry (409 module_disabled).
 * A direct visit goes to the Active tenant page instead of a page that can
 * only show that refusal. While the answer is pending nothing is assumed.
 * If the module state cannot be read, the page is rendered and shows the
 * server's own answer rather than a guess.
 */
export function RequireMultitenant({ children }: { children?: React.ReactNode }): React.ReactElement {
  const { enabled, isPending, isError } = useMultitenant();
  if (isPending) return <LoadingSkeleton variant="page" label="Checking the tenant setup" />;
  if (!enabled && !isError) return <Navigate to="/tenants" replace />;
  return <>{children ?? <Outlet />}</>;
}
